import { BrowserModule }  from '@angular/platform-browser';
import {
  ElectraComponent,
  ElectraDesktopComponent,
  ElectraModule
}                         from './electraLib';
import { NgModule }				from '@angular/core';

declare var window: any;

@NgModule({
  declarations: [],
  imports: [
    BrowserModule,
		ElectraModule.forRoot({
      analyticsKey:   '',
      baseUrl:        'https://dev.api.siteselect.io/v1/',
      brandName:      'site-select-staging',
      doorbellAppID:  '6049',
      doorbellKey:    'V7uOqNkFGaTu8dHYEoFohwN0Rb9oCl2IFrprEdbzHmNzEZFxJeCfjKTRfBibdAg6',
      googleMapsKey:  'AIzaSyD0oANRXEu_6RgVI8ZlCckFSVu21rOsVVg'
    })
  ],
  providers: [],
  bootstrap: [ navigator.userAgent.indexOf('Mobi') !== -1 ? ElectraComponent : ElectraDesktopComponent ]
})
export class AppModule { constructor() { console.log('App launched'); } }



// WEBPACK FOOTER //
// ./src/app/app.module.ts